import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation decryptOfflineReading($data: decryptOfflineReadingInput!) {
    decryptOfflineReading(data: $data) {
      readingCount
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.DecryptOfflineReadingState = {
  result: null,
  error: null,
  loading: false
};

export const decryptOfflineReadingRequest = createAsyncThunk<
  TYPES.DecryptOfflineReadingResponse,
  {data: TYPES.DecryptOfflineReadingInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'reading/decrypt_offline_reading',
  async (
  params: {data: TYPES.DecryptOfflineReadingInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.decryptOfflineReading;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const decryptOfflineReadingSlice = createSlice({
  name: 'decrypt_offline_reading',
  initialState: initialState,
  reducers: {
    decryptOfflineReadingClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(decryptOfflineReadingRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(decryptOfflineReadingRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(decryptOfflineReadingRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { decryptOfflineReadingClear } =
decryptOfflineReadingSlice.actions;

export const decryptOfflineReading = createSelector(
  (state: RootState) => state.reading.decryptOfflineReading.result,
  (state: RootState) => state.reading.decryptOfflineReading.error,
  (state: RootState) => state.reading.decryptOfflineReading.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default decryptOfflineReadingSlice.reducer;